import { instance as CompanyInstance } from '../../../factory/company';
import { logError } from 'src/utils/logger';

module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
  },

  display: async function () {
    INKIVE.hasEditorUnsavedChanges = true;

    const projectData = await INKIVE.PageFactory.getProjectData();
    const isTemplate = INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE;

    if (!this._downloadApp) {
      INKIVE.Modal.togglePageLoader(true);
      const downloadButton = document.querySelector('button[data-action="download"]');
      downloadButton.classList.add('disabled');
      downloadButton.classList.remove('active');

      let didLoadFail = true;
      /**
       * It checks if download/share component were properly loaded. Otherwise, It logs an error
       */
      setTimeout(() => {
        didLoadFail && logError('download.display', 'Display timed out');
      }, 5000);
      INKIVE.Helpers.systemDeferred && await INKIVE.Helpers.systemDeferred;
      await this.load();
      downloadButton.classList.remove('disabled');
      INKIVE.Modal.togglePageLoader(false);

      didLoadFail = false;
    }
    Object.assign(projectData, { isTemplate });
    this.paidDesign && Object.assign(projectData, { is_paid: true });
    this._downloadApp && this._downloadApp.invoke('toggle', projectData);
  },

  load: async function () {
    const { company } = await CompanyInstance.getProjectData();

    CONFIG.company_id = company.id;
    CONFIG.company_name = company.name;

    return (this._loadingPromise = this._loadingPromise || this._load());
  },

  openUpgradeModal: function (paymentOptions) {
    const callbackFunction = () => {
      document.querySelector('.payment-modal > div').classList.add('aurelia-hide');
      if (paymentOptions.upgradeFlavour === 'one-time') {
        this.paidDesign = true;
      } else {
        document.querySelector('[data-id=upgrade]').remove();
        INKIVE.UserInfoFactory.get().then(u => (u.is_on_trial = false));
      }
    };
    INKIVE.Helpers.displaySubscriptionModal('', 'pro', true, null, paymentOptions, callbackFunction);
  },

  _load: async function () {
    const appNode = document.createElement('div');
    appNode.id = 'design-download-modal';
    appNode.setAttribute('aurelia-app', 'design-download-modal/main');
    document.querySelector('#content').appendChild(appNode);
    let didLoadFail = true;
    /**
     * It checks if download/share component were properly loaded. Otherwise, It logs an error
     */
    setTimeout(() => {
      didLoadFail && logError('download._load', 'Aurelia Loading timed out');
    }, 5000);
    CONFIG.is_template = INKIVE.Helpers.isWeBrandTemplate();

    await INKIVE.Helpers.getAureliaLibraries($(appNode));

    const { adapter } = await System.import('@desygner/adapter/adapter');
    this._downloadApp = adapter.getAdapterByDomElement(appNode);
    this._downloadApp && this._setEventListener();

    await new Promise(resolve => INKIVE.Helpers.afterRendering(resolve));
    await INKIVE.EditorFacade.handle('snackbar', 'load');
    didLoadFail = false;
  },

  _setEventListener: function () {
    this._downloadApp.on('toggle-bleed', this._toggleBleed.bind(this));
    this._downloadApp.on('modify-bleed-value', this._modifyBleedValue.bind(this));
    this._downloadApp.on('save-page', this._savePage.bind(this));
    this._downloadApp.on('toggle-snackbar', this._toggleSnackbar.bind(this));
    this._downloadApp.on('get-canvas-info', this._getCanvasInfo.bind(this));
    this._downloadApp.on('get-page-info', this._getPageInfo.bind(this));
    this._downloadApp.on('toggle-notification', this._toggleNotification.bind(this));
  },

  _toggleBleed: function (open) {
    if (open) {
      this.canvas.runExtensions('showBleedClipper', { keepDisabled: true, manage: true, recalculate: true });
      this.canvas.runExtensions('showSafeArea', { keepDisabled: true });
      this.canvas.runExtensions('enableGuideLine', { keepVisible: true });
    } else {
      this.canvas.runExtensions('hideBleedClipper', { keepDisabled: false });
      this.canvas.runExtensions('hideSafeArea', { keepDisabled: false });
      this.canvas.runExtensions('disableGuideLine', { keepVisible: false });
    }
  },

  _modifyBleedValue: function (size) {
    this.canvas.runExtensions('modifyBleedValues', { size });
  },

  _savePage: async function () {
    await INKIVE.EditorFacade.handle('page', 'save');
    this._downloadApp.invoke('saved');
  },

  _toggleSnackbar: function (args) {
    INKIVE.EditorFacade.handle('snackbar', 'display', {
      fileName: args.fileName,
      step: args.step,
      hold: undefined,
      total: args.total
    });
  },

  _getCanvasInfo: async function () {
    const dpi = INKIVE.C.DPI;
    const canvasWidth = this.canvas.contentW;
    const canvasHeight = this.canvas.contentH;
    const initialFormat = await INKIVE.FormatFactory.getCurrentFormat();

    this._downloadApp.invoke('getCanvasInfo', {
      dpi,
      canvasWidth,
      canvasHeight,
      initialFormat
    });
  },

  _getPageInfo: async function (designId) {
    const pageInfo = await INKIVE.PageFactory.getPage(designId);
    this._downloadApp.invoke('getPageInfo', pageInfo);
  },

  _toggleNotification: function (id) {
    this.canvas.call('advice.show', id);
  }

}, Backbone.Events);
